import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {SelectField} from "./FilterComponentStyles";

const PoolFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    label = "fields.poolRegion",
    city = "all",
    marginBottom = "20px",
    showLabel = true,
    placeholder,
    optionFilter = () => true
}) => {
    const {t} = useTranslation(["pools"]);
    const stores = useStore();

    const [poolsLoading, pools, setPools, setPoolsLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolList.bind(null, {
            limit: 1000,
            page: 1,
            city: city
        }),
        dependencies: [city],
        initialCall: initialCall
    });

    return (
        <React.Fragment>
            {showLabel ? (
                <h5>{label ? t(label, {ns: "pools"}) : t("fields.poolRegion", {ns: "pools"})}</h5>
            ) : null}
            <SelectField
                showSearch
                // loading={poolsLoading}
                data-testid="poolSelect"
                value={value}
                onChange={onChange}
                disabled={disabled && poolsLoading}
                mode={mode}
                allowClear={allowClear}
                mb={marginBottom}
                placeholder={placeholder}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {pools?.data &&
                    pools?.data.length > 0 &&
                    arrayAlphabeticalSort([...pools?.data], "name")
                        .filter(optionFilter)
                        .map(pool => (
                            <SelectField.Option
                                key={pool._id}
                                value={pool._id}
                                data-testid="poolSelect_option"
                            >
                                {pool.name}
                            </SelectField.Option>
                        ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PoolFilter;
